export const focusAndScroll = (props) => {
    var _a;
    const { isAllShown, showAllChannelsBtnId, firstHiddenChannelId, lastShownChannelId, getElementById = (id) => document.getElementById(id) } = props;
    const firstHiddenElement = firstHiddenChannelId ? getElementById(firstHiddenChannelId) : null;
    const focusTarget = !isAllShown ? ((_a = firstHiddenElement === null || firstHiddenElement === void 0 ? void 0 : firstHiddenElement.querySelector('button, a')) !== null && _a !== void 0 ? _a : firstHiddenElement) : null;
    focusTarget === null || focusTarget === void 0 ? void 0 : focusTarget.focus();
    const scrollTargetId = isAllShown ? showAllChannelsBtnId : lastShownChannelId;
    const scrollTarget = scrollTargetId ? getElementById(scrollTargetId) : null;
    if (scrollTarget) {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        });
    }
};
